import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import "./styles.css";

class CampaignOptimization extends React.Component {

  constructor(props) {
    super(props);
    this.state = {value: 'ecpi-measurement'};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    alert('You selected: ' + this.state.value);
    console.log(this.state.value)
    event.preventDefault();
  }

  render() {
    return (
      <div className = "App">
        <div>
        <div style={{marginTop:20}}></div>
          <Grid
              container
              direction="column"
              alignItems="center"
              >
              <FormControl onSubmit={() => this.state.value.name}>
              <FormLabel component="legend"></FormLabel>
              <RadioGroup
                  aria-label="campaign-optimization"
                  name="campaign-optimization"
                  value={this.state.value}
                  onChange={this.handleChange}
              >
                  <FormControlLabel id="roas-measurement" name="roas-measurement" value="roas-measurement" control={<Radio />} label="ROAS Measurement" />
                  <FormControlLabel id="pltv-measurement" name="pltv-measurement" value="pltv-measurement" control={<Radio />} label="pLTV Measurement" />
                  <FormControlLabel id="ecpi-measurement" name="ecpi-measurement" value="ecpi-measurement" control={<Radio />} label="eCPI Measurement" />
              </RadioGroup>
              </FormControl>

              {console.log(this.state.value)}
          </Grid>
          <div style={{marginBottom:20}}></div>
        </div>
      </div>
    );
  }
}

export default CampaignOptimization;